export default __webpack_public_path__ + "2373173e1536e6b92316c31c0505f75c.svg";